export default {
  'createBill.purchaseorderno': 'オーダー番号',
  'createBill.IranBranchOffice,No.18,AlvandBuilding,AlvandSt.ArgentinaSq.,Tehran,Iran.Phone:+98 21 88663088':
    'イラン支店：No.18,AlvandBuilding,AlvandSt.ArgentinaSq.,Tehran,Iran.Phone:+98 21 88663088',
  'createBill.date': '日付',
  'createBill.supplieraddress': 'サプライヤーの住所',
  'createBill.3061valiasrsttehraniran': '#3061, Valiasr St,, Tehran, Iran',
  'createBill.requestername': '依頼者名',
  'createBill.paymentterms': '支払い条件',
  'createBill.frominvoicereceipt': 'インボイスの受領から',
  'createBill.projectname': 'プロジェクト名：',
  'createBill.test': 'テスト',
  'createBill.pos': 'POS',
  'createBill.description': '説明',
  'createBill.quantity': '数量',
  'createBill.uom': 'UOM',
  'createBill.netprice': '正味価格',
  'createBill.per': 'あたり',
  'createBill.totalprice': '総計',
  'createBill.curr': '通貨',
  'createBill.deliverydate': '配送日',
  'createBill.NECfullHD1024': 'NEC - Full HD 1024',
  'createBill.sonyultraHD': 'SONY - Ultra HD',
  'createBill.xiaominormalheadset': 'Xiaomi - Normal Headset',
  'createBill.beatshighqualitywireless': 'Beats - High Quality - Wireless',
  'createBill.totalgrossamount': '総合計（税金を含む）',
  'createBill.months': '月',
  'createBill.hours': '時間',
  'createBill.days': '日　',
  'createBill.novartispharmaserviceAG': 'Novartis Pharma Service AG',
};
